/* PDP delivery explainer: independent control for the How It Ships Learn More modal. */
(function () {
  'use strict';

  function start() {
    var modal = document.getElementById('cp-delivery-modal');
    if (!modal || modal.dataset.ctxDeliveryBound === 'true') return;
    modal.dataset.ctxDeliveryBound = 'true';

    var trigger = null;

    function open(source) {
      trigger = source || document.activeElement;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (!window.matchMedia('(pointer: coarse)').matches) {
        var closeButton = modal.querySelector('[data-cp-close-delivery]');
        if (closeButton) setTimeout(function () { closeButton.focus(); }, 50);
      }
    }

    function close() {
      if (modal.hasAttribute('hidden')) return;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (trigger && typeof trigger.focus === 'function') trigger.focus();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('[data-cp-open-delivery]');
      if (opener) { event.preventDefault(); open(opener); return; }
      if (event.target.closest && event.target.closest('[data-cp-close-delivery]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
